import { ValidationLengthUnder255 } from '..';

export const MasterLargeCategoryValidation = (name: string) => (
  // 必須
  !name

  // バリデーション
  || ValidationLengthUnder255.filter((v) => !v.run(String(name || ''))).length
);
